<template>
  <div class="sidebar-content-view sidebar-search active">
    <div v-if="searching || items.length < 1" class="sidebar-content-container white no-padding">
      <TheLoader :active="searching" style="opacity: 0.6"/>

      <div class="center-container" v-if="!searching && items.length < 1">
        <div class="center-content">
          <div class="placeholder-icon"><svg width="44px" height="44px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></div>
          <h2 class="bold">Objektsøk</h2>
          <p v-if="nothingfound">Ingen objekter funna</p>
          <p v-else>Søk etter objekter fra samme kunstner, <br>kategori eller vurdering.</p>
        </div>
      </div>
    </div>

    <overlay-scrollbars v-else-if="items.length > 0" :options="{ className: 'sidebar-content-container white no-padding os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <div class="item-list">
        <span id="hover-card-object-modal-search" class="hover-card right">
          <div class="data-grid">
            <div class="grid-x grid-padding-x grid-padding-small">
              <div class="cell border-bottom hover-card-header">
                <span class="thumbnail medium">
                  <img src="/static/img/object.svg" alt="" class="data-hc-img-src">
                </span>
                <span class="hover-card-content">
                  <span class="item-title">
                    <span class="title data-hc-title">-</span>
                    <span class="subtitle data-hc-subtitle">-</span>
                    <span class="subtitle data-hc-count">-</span>
                  </span>
                </span>
              </div>

              <div class="cell large-6 border-bottom data-hc-price-low-container">
                <div class="dl-wrap">
                  <span class="dl dt data-hc-price-low-header">Lav vurdering</span>
                  <span class="dl dd data-hc-price-low">-</span>
                </div>
              </div>

              <div class="cell large-6 border-bottom data-hc-price-high-container">
                <div class="dl-wrap">
                  <span class="dl dt data-hc-price-high-header">Høy vurdering</span>
                  <span class="dl dd data-hc-price-high">-</span>
                </div>
              </div>

              <div class="cell large-6">
                <div class="dl-wrap">
                  <span class="dl dt">Minstepris</span>
                  <span class="dl dd data-hc-price-min">-</span>
                </div>
              </div>

              <div class="cell large-6">
                <div class="dl-wrap">
                  <span class="dl dt">Tilslag</span>
                  <span class="dl dd data-hc-sold">-</span>
                </div>
              </div>
            </div>
          </div>
        </span>

        <ul class="show-thumbnails">
          <li
            :data-hc-title="itemTitle(item)"
            :data-hc-subtitle="item.Objektnr"
            :data-hc-price-low="itemVurderingLow(item)"
            :data-hc-price-high="itemVurderingHigh(item)"
            :data-hc-price-min="itemMinstepris(item)"
            :data-hc-sold="itemTilslag(item)"
            :data-hc-count="item.Antall !== undefined ? item.Antall : '-'"
            :data-hc-img-src="objektThumb(item)"
            data-hc-id="hover-card-object-modal-search"
            class="hover-card-trigger"
            v-for="item in items"
            v-bind:key="item.Objektid">
            <a href="javascript:;" @click="reloadModalWithObjekt(item)" class="item-link" :class="{'active': item.Objektid === objekt.Objektid}">
              <span class="item-icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object"></use></svg></span>
              <span class="thumbnail small placeholder animation">
                <template v-if="objektThumb(item)">
                  <img :src="objektThumb(item)" />
                </template>
                <template v-else>
                  <span class="placeholder"></span>
                </template>
              </span>
              <span class="item-title">
                <span class="title">{{itemTitle(item) | truncate(40)}}</span>
                <span class="subtitle">{{item.Objektnr}}</span>
              </span>
            </a>
            <span class="button-container has-popover" :class="{'popover-active': actionsPopoverActive.hasOwnProperty(item.Objektid)}" :data-objektid="item.Objektid" @click="toggleActionsPopover(item.Objektid)">
              <a class="item-more-button" href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-more"></use></svg></a>
              <span class="popover align-x-right align-y-bottom small">
                <ul>
                  <li><a :href="itemKundeLink(item)" ><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis kunde</span></a></li>
                  <li><a :href="itemKontraktLink(item)" ><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg> <span>Vis kontrakt</span></a></li>
                  <li><a :href="itemObjektLink(item)" ><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-new-window"></use></svg> <span>Vis objekt</span></a></li>
                </ul>
              </span>
            </span>
          </li>
        </ul>
      </div>

      <div class="pagination-container"  v-if="pageCount > 1" style="margin-top: 1.5rem;">
        <paginate v-model="currentPage"
          :page-count="pageCount"
          :page-range="3"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </overlay-scrollbars>

    <form @submit.prevent="runSubmit">
      <div class="grid-x toolbar footer">
        <!-- Begin Advanced Search -->
        <div class="cell">
          <div class="sidebar-search-settings">
            <div class="grid-x grid-padding-x">
              <div class="cell small-6">
                <label for="price_from">Vurdering fra</label>
                <div class="input-container currency symbol-glyph" data-symbol="kr">
                  <input type="text" v-model="searchParams.price_from" id="price_from" placeholder="0">
                </div>
              </div>

              <div class="cell small-6">
                <label for="price_to">Vurdering til</label>
                <div class="input-container currency symbol-glyph" data-symbol="kr">
                  <input type="text" v-model="searchParams.price_to" id="price_to" placeholder="10 000">
                </div>
              </div>

              <TheAutoCompleteInput v-model.trim="searchParams.Kunstner" containerClassName="cell" :placeholder="'Velg kunstner…'" :label="'Kunstner'" :onInputCallback="onKunstnerSearchInput" :onSelectCallback="onKunstnerSearchSelected" :onResetCallback="onKunstnerReset" :debounce="750" :minquery="2">
                <div slot="item" slot-scope="props">
                  <span v-if="props.item.val">
                    {{ props.item.val }}<span v-if="props.item.period">, {{ props.item.period }}</span>
                  </span>
                  <span v-else>
                    {{ props.item.key }}<span v-if="props.item.period">, {{ props.item.period }}</span>
                  </span>
                </div>
              </TheAutoCompleteInput>

              <div class="cell large-6">
                <label for="ddate_from">Fra dato</label>
                <div class="input-container date">
                  <input type="date" v-model="searchParams.date_from" id="date_from">
                  <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                </div>
              </div>

              <div class="cell large-6">
                <label for="date_to">Til dato</label>
                <div class="input-container date">
                  <input type="date" v-model="searchParams.date_to" id="date_to">
                  <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Advanced Search -->

        <div class="cell">
          <div class="input-container search no-margin">
            <input class="rounded" v-model="searchParams.query" type="search" placeholder="Søk etter objekt…">
            <a href="javascript:;" @click="toggleSearchSettings()" class="search-settings" :class="{'active': searchSettings}"><svg width="20px" height="15px" viewBox="0 0 20 15"><use xlink:href="/static/sprites.svg#search-settings-glyph"></use></svg></a>
            <button class="glyph-button" type="submit">Send <svg width="14px" height="14px" viewBox="0 0 14 14"><use xlink:href="/static/sprites.svg#glyph-input-search"></use></svg></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import KunstnerService from '@/services/KunstnerService'
import SearchService from '@/services/SearchService'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
import accounting from 'accounting-js'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektSidebar',
  components: {
    TheAutoCompleteInput
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      searching: false,
      searchSettings: true,
      nothingfound: false,
      searchParams: {},
      items: [],
      page: 1,
      currentPage: 1,
      pageCount: 1,
      totalCount: 0,
      actionsPopoverActive: {}
    }
  },
  created () {
    this.searchParams = {
      date_from: null,
      date_to: null,
      price_from: null,
      price_to: null,
      Kunstner: this.objekt.kunstner ? this.objekt.kunstner.Navn : '',
      Kunstnerid: this.objekt.kunstner ? this.objekt.kunstner.Idnr : null,
      query: ''
    }

    var $hcID = null
    var vm = this

    window.jQuery('body').on('mouseenter', '.hover-card-trigger', function () {
      // defining data variables
      $hcID = window.jQuery(this).attr('data-hc-id')
      let $hcTitle = window.jQuery(this).attr('data-hc-title')
      let $hcSubTitle = window.jQuery(this).attr('data-hc-subtitle')
      let $hcCount = window.jQuery(this).attr('data-hc-count')
      let $hcPriceLow = window.jQuery(this).attr('data-hc-price-low')
      let $hcPriceHigh = window.jQuery(this).attr('data-hc-price-high')
      let $hcPriceMin = window.jQuery(this).attr('data-hc-price-min')
      let $hcSold = window.jQuery(this).attr('data-hc-sold')
      let $hcImgSrc = window.jQuery(this).attr('data-hc-img-src') || '/static/img/object.svg'

      // update card with new data
      window.jQuery('#' + $hcID).find('.data-hc-title').html($hcTitle)
      window.jQuery('#' + $hcID).find('.data-hc-subtitle').html($hcSubTitle)
      window.jQuery('#' + $hcID).find('.data-hc-count').html('Antall: ' + $hcCount)

      window.jQuery('#' + $hcID).find('.data-hc-price-low').html($hcPriceLow)
      window.jQuery('#' + $hcID).find('.data-hc-price-high').html($hcPriceHigh)

      window.jQuery('#' + $hcID).find('.data-hc-price-min').html($hcPriceMin)
      window.jQuery('#' + $hcID).find('.data-hc-sold').html($hcSold)
      window.jQuery('#' + $hcID).find('.data-hc-img-src').attr('src', '/static/img/object.svg')
      window.jQuery('#' + $hcID).find('.data-hc-img-src').attr('src', $hcImgSrc)

      // defining offset and position variables
      let $offsetTop = window.jQuery(this).offset().top
      let $offsetHeight = window.jQuery(this).height()
      let $offsetBottom = window.innerHeight - $offsetTop - $offsetHeight
      let $hoverCardHeight = window.jQuery('#' + $hcID).height()
      let $hoverCardWidth = window.jQuery('#' + $hcID).width()

      // show the card if not already activeted
      if (!window.jQuery('#' + $hcID).hasClass('active')) {
        window.jQuery('#' + $hcID).addClass('active')

        window.jQuery(document).bind('mousemove', function (e) {
          // hide the hover card if a contextual popover menu is activated
          if (window.jQuery('.popover-active').length) {
            window.jQuery('#' + $hcID).removeClass('active')
            window.jQuery(document).unbind('mousemove', function (e) {})
          } else {
            // make the card follow the mouse pointer
            // making sure the cards height is not taller than the remaining viewport bottom space
            if ($offsetBottom > $hoverCardHeight) {
              window.jQuery('#' + $hcID + '.hover-card.left').css({
                left: e.pageX + 40,
                top: e.pageY + 30
              })
              window.jQuery('#' + $hcID + '.hover-card.right').css({
                left: e.pageX - $hoverCardWidth * 1.25 - 80,
                top: e.pageY + 30
              })
            } else {
              // offset the card if to close to bottom
              window.jQuery('#' + $hcID + '.hover-card.left').css({
                left: e.pageX + 40,
                top: e.pageY - $hoverCardHeight
              })
              window.jQuery('#' + $hcID + '.hover-card.right').css({
                left: e.pageX - $hoverCardWidth * 1.25 - 80,
                top: e.pageY - $hoverCardHeight
              })
            }
          }
        })
      }
    })

    window.jQuery('body').on('mouseleave', '.hover-card-trigger', function () {
      window.jQuery('#' + $hcID).removeClass('active')
      window.jQuery(document).unbind('mousemove', function (e) {})
      window.jQuery('.has-popover').removeClass('popover-active')
      vm.$set(vm, 'actionsPopoverActive', {})
    })
  },
  mounted () {
    // Listen to submit form event from parent - cus button is in parent
    this.nothingfound = false

    var vm = this
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.$set(vm, 'actionsPopoverActive', {})
      }
    })
  },
  methods: {
    toggleSearchSettings: function () {
      window.jQuery('.sidebar-search-settings').toggleClass('active').slideToggle(400)

      this.searchSettings = !this.searchSettings
    },
    toggleActionsPopover: function (Objektid) {
      if (this.actionsPopoverActive.hasOwnProperty(Objektid)) {
        this.$delete(this.actionsPopoverActive, Objektid)
      } else {
        this.$set(this.actionsPopoverActive, Objektid, 1)
      }
    },
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
    },
    objektThumbLoaded: function (item) {
      item.Fototatt = 'T'
    },
    itemTitle: function (item) {
      if (item.subtitle) {
        return item.title + ' / ' + item.subtitle
      }

      return item.title
    },
    itemVurderingLow: function (item) {
      if (item.Vurderingspris2 > 0) {
        return accounting.formatNumber(item.Vurderingspris2, { precision: 0, thousand: ' ' })
      } else if (item.Vurderingspris2 === '0' || item.Vurderingspris2 === 0) {
        return '0'
      }

      return '-'
    },
    itemVurderingHigh: function (item) {
      if (item.Vurderingspris1 > 0) {
        return accounting.formatNumber(item.Vurderingspris1, { precision: 0, thousand: ' ' })
      } else if (item.Vurderingspris1 === '0' || item.Vurderingspris1 === 0) {
        return '0'
      }

      return '-'
    },
    itemMinstepris: function (item) {
      if (item.Minstepris > 0) {
        return accounting.formatNumber(item.Minstepris, { precision: 0, thousand: ' ' })
      } else if (item.Minstepris === '0' || item.Minstepris === 0) {
        return '0'
      }

      return '-'
    },
    itemTilslag: function (item) {
      if (this._.startsWith(item.Auksjon, 'AR')) {
        return 'Usolgt'
      } else if (item.Salgspris > 0) {
        return accounting.formatNumber(item.Salgspris, { precision: 0, thousand: ' ' })
      } else if (item.Salgspris === '0' || item.Salgspris === 0) {
        return '0'
      }

      return '-'
    },
    itemObjektLink: function (item) {
      return '/kunde/' + item.innlevav.Kundenr + '?kontrakt=' + item.Kontraktnr + '&objekt=' + item.Objektid
    },
    itemKontraktLink: function (item) {
      return '/kunde/' + item.innlevav.Kundenr + '?kontrakt=' + item.Kontraktnr
    },
    itemKundeLink: function (item) {
      return '/kunde/' + item.innlevav.Kundenr
    },
    reloadModalWithObjekt: function (item) {
      if (this.isFormDirty('objektform')) {
        this.$helpers.showErrorAlert('', 'Du har gjort endringer på objektet,<br>vennligst lagre før du går videre.', true)
      } else {
        bus.$emit('objekt-modal-switch', item)

        if (this.kontrakt.Kontraktnr !== item.Kontraktnr) {
          // Load kontrakt->objekt - always load on mount
          this.$store.dispatch('kundekontraktobjekt/load', item.kontrakt)
        }
      }
      /*
      else if (item.Kontraktnr === this.kontrakt.Kontraktnr) {
        bus.$emit('reload-kunde-kontrakt-objekt-modal', this.kontrakt, item)
      } else {
        console.log('Cant reload as not obj in same kontrakt')
      }
      */
    },
    onKunstnerSearchInput: function (query) {
      return new Promise(resolve => {
        KunstnerService.search(query, 1)
          .then((response) => {
            const found = response.data.map(x => {
              return { key: x.Idnr, val: x.name_original, period: x.period_dates || '' }
            })

            resolve({ data: found })
          })
      })

      // Old
      // return KunstnerService.search(query)
    },
    onKunstnerSearchSelected: function (item) {
      if (!item) {
        this.searchParams.Kunstner = ''
        this.searchParams.Kunstnerid = null
      } else {
        this.searchParams.Kunstner = item.val || ''
        this.searchParams.Kunstnerid = item.key || null
      }
    },
    onKunstnerReset: function () {
      this.searchParams.Kunstner = ''
      this.searchParams.Kunstnerid = null
    },

    changePage: function (page) {
      let vm = this

      window.jQuery('.sidebar-content-container').animate({
        scrollTop: 0
      }, 200, function () {
        if (page !== vm.page) {
          vm.page = page
          vm.handleSubmit()
        }
      })
    },

    runSubmit: function () {
      this.page = 1
      this.currentPage = 1

      this.handleSubmit()
    },

    handleSubmit: function () {
      this.nothingfound = false
      this.searching = true

      // Prepare the data for searching
      let searchdata = {
        Registrert_dato: {},
        Vurderingspris: {},
        // Kategori: [],
        // Auksjon: [],
        Kunstner: '',
        Kunstnerid: null,
        query: this.searchParams.query
      }

      if (this.searchParams.date_from) {
        searchdata.Registrert_dato.from = this.searchParams.date_from
      }

      if (this.searchParams.date_to) {
        searchdata.Registrert_dato.to = this.searchParams.date_to
      }

      if (this.searchParams.price_from) {
        searchdata.price_from = this.searchParams.price_from
      }

      if (this.searchParams.price_to) {
        searchdata.price_to = this.searchParams.price_to
      }

      if (this.searchParams.Kunstnerid) {
        searchdata.Kunstnerid = this.searchParams.Kunstnerid
      } else if (this.searchParams.Kunstner) {
        searchdata.Kunstner = this.searchParams.Kunstner
      }

      // Hide advanced search
      if (this.searchSettings) {
        window.jQuery('.sidebar-search-settings').removeClass('active').slideToggle(400)
      }
      this.searchSettings = false

      // Do search
      SearchService.objekt(searchdata, this.page)
        .then((response) => {
          this.items = response.data
          this.pageCount = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.totalCount = response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Warning', 'Ingen objekter funna.')
        })
        .then(() => {
          this.searching = false
          this.nothingfound = this.items.length < 1
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektSidebarSearch.vue